define('components/handlers/tool-menu',[
    'jquery',
    'components/decorator',
    'components/util/tool-menu'
], function($, decorator, toolMenu) {


    $.extend(companyInfo.handlers, {

        'tool-menu': function (e) {
          e.preventDefault();
          var el = $(this);

          var atElement = el.data('at-element');
          var candidate = el.find(atElement);
          var className = el.data('toolmenu-class');

          atElement = candidate.length ? candidate : el;
          var content = atElement.data("tooltip-content");



          //if there is no content, pleasse check if there is a element which has the content
          if(!content){
            var contentElm = el.find("[data-content]");

            if(contentElm.length){
              content = document.createElement("div");
              content.innerHTML = contentElm.first().html();
            }
          }

          if (!content) {
            var contentScript = el.find('script[type="text/content"]');
            content = document.createElement("div");
            content.innerHTML = contentScript.html();
          }

          if (toolMenu.isCurrent(atElement[0])) {
            toolMenu.hide();
          } else {
            toolMenu.show(content, atElement[0],className);
            decorator.run();
          }
        }

    });

});

